import { useTranslation } from 'react-i18next'
import type { BadgeState } from './badge-state'

const TONE_CLASSES: Record<BadgeState['tone'], string> = {
  amber:
    'border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200',
  neutral:
    'border-stone-300 bg-stone-100 text-stone-700 dark:border-stone-700 dark:bg-stone-800 dark:text-stone-200',
  blue:
    'border-sky-300 bg-sky-50 text-sky-900 dark:border-sky-700 dark:bg-sky-950 dark:text-sky-200',
}

const DOT_CLASSES: Record<BadgeState['tone'], string> = {
  amber: 'bg-amber-500',
  neutral: 'bg-stone-500',
  blue: 'bg-sky-500',
}

export interface StatusBadgeProps {
  state: BadgeState
}

export function StatusBadge({ state }: StatusBadgeProps) {
  const { t } = useTranslation()
  return (
    <span
      data-testid="bc-status-badge"
      data-tone={state.tone}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${TONE_CLASSES[state.tone]}`}
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${DOT_CLASSES[state.tone]}`} />
      {t(state.label.key, state.label.params)}
    </span>
  )
}
